import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, roles, requiredPermission }) {
  const { user, loading, hasPermission } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-[#4A5568]">
        <div className="font-overline">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;

  // ── Phase G (2026-02): Subscriber Responsibilities / FCRA
  // acknowledgment gate. PM users must accept the current version before
  // touching any protected surface. The gate is enforced authoritatively
  // by the backend (`get_current_user` returns 428) — this redirect is
  // pure UX so we don't send them into a route that will fail.
  if (
    user.role === "property_manager" &&
    user.requires_subscriber_ack &&
    location.pathname !== "/subscriber-acknowledgment"
  ) {
    return <Navigate to="/subscriber-acknowledgment" replace />;
  }

  if (roles && !roles.includes(user.role)) return <Navigate to="/dashboard" replace />;
  // Phase D: permission-gated routes. NTN staff bypass client permission
  // gates (they authorize via the `roles` prop above). For a client user,
  // missing effective permissions redirect them to /access-denied.
  if (requiredPermission && user.role !== "ntn_staff" && !hasPermission(requiredPermission)) {
    return <Navigate to="/access-denied" replace />;
  }
  return children;
}
